import { render, staticRenderFns } from "./SearchContractAndPickupPage.vue?vue&type=template&id=5a4502f1&scoped=true"
import script from "./SearchContractAndPickupPage.vue?vue&type=script&lang=ts"
export * from "./SearchContractAndPickupPage.vue?vue&type=script&lang=ts"
import style0 from "./SearchContractAndPickupPage.vue?vue&type=style&index=0&id=5a4502f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4502f1",
  null
  
)

export default component.exports